module.exports = __webpack_public_path__ + "img/42_18.c0c648fc.png";